import _ from "lodash";
import React, { useState, useEffect } from "react";
import { connect, ConnectedProps } from "react-redux";
import styled from "styled-components";
import { displayLocation } from "sweet-global";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import { bindActionCreators, Dispatch } from "redux";
import * as selectors from "sweet-web/redux/selectors";
import { searchFocus } from "sweet-web/redux/search/actions";

const Wrapper = styled.div<{ visible: boolean; pointerEvents: boolean }>`
  display: flex;
  pointer-events: ${props => (props.pointerEvents ? "box" : "none")};
  flex-direction: column;
  position: absolute;
  top: 40px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border: 1px solid ${colors.lightGray};
  background-color: ${colors.white};
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  opacity: ${props => (props.visible ? 1 : 0)};
  box-shadow: rgba(0, 0, 0, 0.08) 0 3px 10px 0;
  width: 100%;
  padding: 5px 0;
  z-index: 61;
`;

const SearchResult = styled.a`
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  justify-content: center;
  align-items: flex-start;
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  text-decoration: none;
  &:hover {
    background-color: ${colors.lighterGray};
  }
`;

const SearchResultTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.nearBlack};
`;

const SearchResultLabel = styled.p`
  font-size: 12px;
  color: ${colors.gray};
  font-weight: 500;
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 60;
`;

type Props = ConnectedProps<typeof connector>;

const Results: React.FC<Props> = props => {
  const { results, focused, userType, searchFocus } = props;

  const [pointerEvents, setPointerEvents] = useState(false);

  useEffect(() => {
    if (focused) setPointerEvents(true);
    else if (!focused) setTimeout(() => setPointerEvents(true), 200);
  }, [focused]);

  return (
    <React.Fragment>
      {focused && <Overlay onClick={() => searchFocus(false)} />}
      <Wrapper
        visible={focused && results.length > 0}
        pointerEvents={pointerEvents}
      >
        {results.map(result => (
          <SearchResult
            key={`search-result-${result.id}`}
            href={
              userType === "ADMIN"
                ? `/listing/${result.id}/preview`
                : `/v/${result.id}`
            }
          >
            <SearchResultTitle>{result.name}</SearchResultTitle>
            <SearchResultLabel>
              {displayLocation(result.location)}
            </SearchResultLabel>
          </SearchResult>
        ))}
      </Wrapper>
    </React.Fragment>
  );
};

const mapState = (state: RootState) => ({
  results: selectors.searchResults(state),
  focused: selectors.searchFocused(state),
  userType: selectors.userType(state)
});
const mapDispatch = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      searchFocus
    },
    dispatch
  );
const connector = connect(mapState, mapDispatch);

export default connector(Results);
